import React from 'react';
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "reactstrap";
import { unBlockWorkstations } from "../../store/actions";



const UnBlockWorkstation= function(props){
    let ws=props.ws
    
    let user=JSON.parse(localStorage.getItem("authUser"))

    const unblcokWorkstations=(event)=>{
        event.preventDefault()
        props.unBlockWorkstations(ws,user.token,props.history)
    }
   
  
    return(
        <React.Fragment>
            <Button className="btn btn-success waves-effect waves-light buttonStatus wsButton" onClick={(event)=>unblcokWorkstations(event)}>  <i className="bx bx-lock-open font-size-16 align-middle mr-2"/></Button>
            

        </React.Fragment>
    )
}


const mapStateProps = (state) => {
   
    const {  loadingUnBlockWs} = state.UnBlockWorkstation;
    
    return { loadingUnBlockWs};
  };
  
export default withRouter(
    connect(mapStateProps, {
        unBlockWorkstations
    })(withNamespaces()(UnBlockWorkstation))
  );